/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { HealthRecord } from "../../models/health-record";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetIotnetGatewayHealth$Params {
  customer_id: string;
  gateway_id: string;
}

export function getIotnetGatewayHealth(
  http: HttpClient,
  rootUrl: string,
  params: GetIotnetGatewayHealth$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<HealthRecord>> {
  const rb = new RequestBuilder(rootUrl, getIotnetGatewayHealth.PATH, "get");
  if (params) {
    rb.path("customer_id", params.customer_id, {});
    rb.path("gateway_id", params.gateway_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HealthRecord>;
    }),
  );
}

getIotnetGatewayHealth.PATH = "/stats/customers/{customer_id}/iotnet-gateways/{gateway_id}/health";
